<template lang="pug">
.wrapperr(v-if='ativarJanela')
    .bloco(:class='alterarPosicaoBloco')
        .bloco-head(@click='minimizarBloco = !minimizarBloco')
            h2 {{ $t('mensagens.preAnaliseCredito.exportarDocumento.titulo') }}
            i.mdi.bloco-icon.mdi-chevron-right(
                :class='[minimizarBloco ? "mdi-window-minimize" : "mdi-window-maximize"]'
            )

        transition(name='slide')
            .bloco-body(v-if='minimizarBloco')
                .bloco-lista(v-if='steps == "listagem"')
                    ul
                        li(
                            v-for='item in marcarExportarNeowayPDF',
                            :key='item.idLista'
                        )
                            .item
                                span(style='margin-bottom: 3px') {{ item.documento }}
                                span {{ mxNormalisarNomes(item.nome) }}
                            .i.mdi.mdi-trash-can-outline(
                                @click='excluirArquivo(item.idLista, item.nome, item.documento)'
                            )

                    .bloco-footer(:class='alterarPosicaoBloco')
                        BaseButton(@click='handleCancelar()') {{ $t('mensagens.comuns.cancelar') }}
                        BaseButton(type='primary', @click='handleExportar') {{ $t('mensagens.comuns.exportar') }}

                .loading(v-if='steps == "processamento"')
                    i.el-icon-loading
                    p {{ $t('mensagens.preAnaliseCredito.exportarDocumento.exportacaoSendoProcessada') }}
    BaseModalExcluirItemExportacao(
        :mostrarDialog='mostrarDialog',
        :documento='itemDocumento',
        :nome='itemNome',
        @cancelar='cancelarAcao',
        @remover='removerItem'
    )
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import store from '@/store';

import PreAnaliseService from '@/modules/pre-analise-credito/services/PreAnaliseCredito';

import BaseModalExcluirItemExportacao from './BaseModalExcluirItemExportacao.vue';
import BaseModalVisualizarInfos from '@/modules/pre-analise-credito/components/BaseModalVisualizarInfos';

import preAnaliseServiceMixin from '@/modules/pre-analise-credito/mixins/PreAnaliseCreditoMixin';

import BaseButton from './BaseButton.vue';

export default {
    name: 'ExportarDocumentoAnaliseCredito',

    components: {
        BaseModalExcluirItemExportacao,
        BaseModalVisualizarInfos,
        BaseButton
    },

    mixins: [preAnaliseServiceMixin],

    data() {
        return {
            minimizarBloco: false,
            ativarJanela: false,
            steps: 'listagem',
            tamanhoListagem: null,
            mostrarDialog: false,
            itemId: null,
            itemDocumento: '',
            itemNome: ''
        };
    },

    computed: {
        ...mapGetters([
            'marcarExportarNeowayPDF',
            'marcarExportarPDF',
            'usuarioLogado'
        ]),
        alterarPosicaoBloco() {
            const alterarPosicaoBloco =
                this.marcarExportarNeowayPDF?.length > 0 &&
                this.marcarExportarPDF?.length > 0 &&
                this.emProcessamentoUploadLoteRenovabio &&
                this.emProcessamentoDownloadLoteRenovabio;
            return alterarPosicaoBloco ? 'blocos-ativos' : '';
        }
    },

    watch: {
        marcarExportarNeowayPDF(newValue) {
            if (newValue?.length !== 0) {
                this.ativarJanela = true;
                this.minimizarBloco = true;
            }
        }
    },

    methods: {
        ...mapActions([
            'setMarcarExportarNeoway_PDF',
            'removeMarcarExportarNeoway_PDF',
            'clearMarcarExportarNeoway_PDF',
            'setEmProcessamentoNeoway_PDF'
        ]),

        excluirArquivo(id, nome, documento) {
            this.mostrarDialog = true;
            this.itemId = id;
            this.itemDocumento = documento;
            this.itemNome = nome;
        },

        cancelarAcao() {
            this.mostrarDialog = false;
            this.itemId = null;
            this.itemNome = '';
            this.itemDocumento = '';
        },
        removerItem() {
            this.removeMarcarExportarNeoway_PDF(this.itemId);
            this.mostrarDialog = false;
            this.itemId = null;
            this.itemNome = '';
            this.itemDocumento = '';

            if (this.marcarExportarPDF.length === 0) {
                this.ativarJanela = false;
            }
        },
        async handleCancelar() {
            const result = await this.$messageBox.confirm(
                this.$t(
                    'mensagens.preAnaliseCredito.desejaCancelarListaExportacao'
                ),
                this.$t('mensagens.preAnaliseCredito.aviso'),
                {
                    confirmButtonText: this.$t('mensagens.comuns.sim'),
                    cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                    type: 'warning'
                }
            );

            if (result) {
                this.clear();
            }
        },

        clear() {
            this.clearMarcarExportarNeoway_PDF();
            this.ativarJanela = false;
            this.steps = 'listagem';
        },

        handleExportar() {
            this.steps = 'processamento';
            this.setEmProcessamentoNeoway_PDF();
            this.tamanhoListagem = store.state.marcarExportarNeowayPDF.length;

            store.state.marcarExportarNeowayPDF.forEach(p => {
                this.exportarPdfPreAnaliseCredito(
                    p.numeroCpfCnpj,
                    p.idConsulta
                );
            });
        },

        async exportarPdfPreAnaliseCredito(cpfCnpj, idConsulta) {
            let opcoesExportacao_ = [];

            if (cpfCnpj.length === 11) {
                opcoesExportacao_ = [
                    this.$t(
                        'mensagens.preAnaliseCredito.modulos.dadosFinanceiros'
                    ),
                    this.$t(
                        'mensagens.preAnaliseCredito.modulos.dadosFiscaisTributarios'
                    ),
                    this.$t(
                        'mensagens.preAnaliseCredito.modulos.informacoesProfissionais'
                    ),
                    this.$t(
                        'mensagens.preAnaliseCredito.modulos.informacoesPublicasBndes'
                    ),
                    this.$t('mensagens.preAnaliseCredito.modulos.patrimonio'),
                    this.$t(
                        'mensagens.preAnaliseCredito.modulos.pessoaPoliticamenteExposta'
                    ),
                    this.$t(
                        'mensagens.preAnaliseCredito.modulos.processosJudiciais'
                    ),
                    this.$t(
                        'mensagens.preAnaliseCredito.modulos.relacionamentos'
                    ),
                    this.$t(
                        'mensagens.preAnaliseCredito.modulos.sancoesRestricoes'
                    )
                ];
            } else if (cpfCnpj.length === 14) {
                opcoesExportacao_ = [
                    this.$t(
                        'mensagens.preAnaliseCredito.modulos.dadosFinanceiros'
                    ),
                    this.$t('mensagens.preAnaliseCredito.modulos.dadosFiscais'),
                    this.$t(
                        'mensagens.preAnaliseCredito.modulos.informacoesPublicasBndes'
                    ),
                    this.$t('mensagens.preAnaliseCredito.modulos.patrimonio'),
                    this.$t(
                        'mensagens.preAnaliseCredito.modulos.processosJudiciais'
                    ),
                    this.$t(
                        'mensagens.preAnaliseCredito.modulos.relacionamentos'
                    ),
                    this.$t(
                        'mensagens.preAnaliseCredito.modulos.sancoesRestricoes'
                    )
                ];
            }
            try {
                await PreAnaliseService.exportarPdfNeoway(
                    opcoesExportacao_,
                    cpfCnpj,
                    idConsulta
                );
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.preAnaliseCredito.erro.exportarAnalise'
                    )
                });
            }
            this.tamanhoListagem = this.tamanhoListagem - 1;
            if (this.tamanhoListagem === 0) {
                this.clear();
            }
        }
    }
};
</script>
<style lang="scss" scoped>
.minimizar-enter-active,
.minimizar-leave-active {
    transition: opacity 0.5s ease;
}

.minimizar-enter-from,
.minimizar-leave-to {
    opacity: 0;
}
.wrapperr {
    position: fixed;
    bottom: 0;
    right: 3px;
    z-index: 20000;
}

.bloco {
    position: absolute;
    right: 17px;
    bottom: 0px;
    background: var(--white);
    width: 400px;
    border-radius: 5px 5px 0px 0px;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.blocos-ativos {
    right: 325px !important;
}
.bloco-head {
    width: inherit;
    height: 45px;
    background: var(--primary);
    padding: 8px;
    border-radius: 5px 5px 0px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}
.bloco-head h2 {
    color: var(--white);
    display: inline-block;
    font-size: 14px;
}
.bloco-head .bloco-icon {
    color: var(--white);
    font-size: 24px;
    cursor: pointer;
}
.bloco-body {
    height: 216px;
    width: inherit;
    overflow: auto;
    margin-bottom: 53px;
}
.bloco-lista {
    .item {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
    }
}
.bloco-lista ul {
    list-style: none;
    margin: 0;
    padding: 9px;
}
.bloco-lista ul li {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0;
    padding: 0;
    align-items: center;
    line-height: 17px;
    margin-bottom: 12px;
}
.bloco-lista ul li .mdi {
    font-size: 17px;
    color: #545454;
    cursor: pointer;
}
.bloco-lista ul li .mdi:hover {
    color: red;
}
.bloco-lista ul li span {
    font-size: 12px;
}
.bloco-footer {
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    width: 400px;
    padding: 0px 4px 4px 4px;
}

.slide-enter-active {
    -moz-transition-duration: 0.2s;
    -webkit-transition-duration: 0.2s;
    -o-transition-duration: 0.2s;
    transition-duration: 0.2s;
    -moz-transition-timing-function: linear;
    -webkit-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
}

.slide-leave-active {
    -moz-transition-duration: 0.2s;
    -webkit-transition-duration: 0.2s;
    -o-transition-duration: 0.2s;
    transition-duration: 0.2s;
}

.slide-enter-to,
.slide-leave {
    max-height: 100px;
    overflow: hidden;
}

.slide-enter,
.slide-leave-to {
    overflow: hidden;
    max-height: 0;
}

.loading {
    i {
        font-size: 35px;
        margin-bottom: 20px;
    }

    padding: 30px 20px;
    text-align: center;
}

.download {
    padding: 80px 20px 0px;
    text-align: center;
}

.el-message-box {
    width: 500px !important;
}

.el-message-box__btns {
    button {
        width: 100px !important;
    }

    .el-button--primary {
        background-color: var(--primary);
        border-color: var(--primary);
        color: var(--white);
    }

    .el-button--primary:hover,
    .el-button--primary:focus {
        background-color: var(--secondary);
        border-color: var(--secondary);
        color: var(--color-button-hover);
        outline: 0px auto var(--secondary);
    }
}
</style>
